import React from 'react'
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../styles/colors';


const SearchInput = ({searchText, onChange, label}) => {
  return (
    <TextField
      variant="outlined"
      type='text'
      margin="dense"
      label={label ? label : 'Search'}
      value={searchText}
      onChange={(e) => onChange(e)}
      style={{width: 'auto'}}
      InputProps={{
        endAdornment: (
          <FontAwesomeIcon
            icon="search"
            style={{
              color: COLORS.grey
            }}/>
        ),
      }}
    />
  )
}

export default SearchInput



// WEBPACK FOOTER //
// ./src/components/SearchInput.js